import { defineComponent as _defineComponent } from 'vue'
import {useRouter} from 'vue-router'
import { ref, computed } from 'vue'
import { Size } from '../components/basic_button/size'
import { delete_user, list_users } from '../module/users/module'
import { computedAsync } from '@vueuse/core'
import Paginator from '../components/paginator.vue';
import EditUser from './Users/edit_user.vue';
import ChangePassword from './Users/change_password.vue';
import CreateRegistrationToken from './Users/create_registration_token.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'Users',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter()

let search_text = ref("")
let page_size = ref(50)
let current_page = ref(1)
let dat_reset = ref(false)
let dat_selected_user = ref({})
let dat_open_edit_user = ref(false)
let dat_open_change_password = ref(false)
let dat_open_create_registration_token = ref(false)


const users = computedAsync(
        

        async () => {
            const reset = dat_reset.value
            return await list_users(
                search_text.value,
                current_page.value,
                page_size.value,
            )
        },
        {
            results: [],
            total_count: 0
        }, /* initial state */
    )

// const users = ref([
//     {
//         id: 1,
//         Username: "test 1",
//         Email: "test1@email.com",
//         is_editing: false
//     },
//     {
//         id: 2,
//         Username: "test 2",
//         Email: "test2@email.com",
//         is_editing: false
//     },
//     {
//         id: 3,
//         Username: "test 3",
//         Email: "test3@email.com",
//         is_editing: false
//     },
//     {
//         id: 4,
//         Username: "test 4",
//         Email: "test4@email.com",
//         is_editing: false
//     },
//     {
//         id: 5,
//         Username: "test 5",
//         Email: "test5@email.com",
//         is_editing: false
//     },
// ])

const new_user = function() {
    console.log('new_user')
    dat_selected_user.value = { id: null }
    dat_open_create_registration_token.value = !dat_open_create_registration_token.value
}

const reset_password = function(arg_user) {
    dat_selected_user.value = arg_user
    dat_open_create_registration_token.value = !dat_open_create_registration_token.value
}

const edit_user = function(arg_user) {
    dat_selected_user.value = arg_user
    dat_open_edit_user.value = !dat_open_edit_user.value
}

const change_password = function(arg_user) {
    dat_selected_user.value = arg_user
    dat_open_change_password.value = !dat_open_change_password.value
}

const del_user = async function(arg_user) {
    const finished = await delete_user(arg_user)
    if (finished) {
        dat_reset.value = !dat_reset.value
    }
    
}


const __returned__ = { router, get search_text() { return search_text }, set search_text(v) { search_text = v }, get page_size() { return page_size }, set page_size(v) { page_size = v }, get current_page() { return current_page }, set current_page(v) { current_page = v }, get dat_reset() { return dat_reset }, set dat_reset(v) { dat_reset = v }, get dat_selected_user() { return dat_selected_user }, set dat_selected_user(v) { dat_selected_user = v }, get dat_open_edit_user() { return dat_open_edit_user }, set dat_open_edit_user(v) { dat_open_edit_user = v }, get dat_open_change_password() { return dat_open_change_password }, set dat_open_change_password(v) { dat_open_change_password = v }, get dat_open_create_registration_token() { return dat_open_create_registration_token }, set dat_open_create_registration_token(v) { dat_open_create_registration_token = v }, users, new_user, reset_password, edit_user, change_password, del_user, get Size() { return Size }, Paginator, EditUser, ChangePassword, CreateRegistrationToken }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})